var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.923 2.885H3.077C1.93 2.885 1 3.815 1 4.962v12.461c0 1.147.93 2.077 2.077 2.077h13.846c1.147 0 2.077-.93 2.077-2.077V4.962c0-1.147-.93-2.077-2.077-2.077z",
    stroke: "#ED1B2E",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.346H1M4.462 1.5v1.385V1.5zm11.076 0v1.385V1.5z",
    stroke: "#ED1B2E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgCalendarIcon;